import { Component } from '@angular/core';
import { SettingPipe } from '@app/shared/pipes/setting.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import packageJson from '../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [
    SettingPipe,
    TranslatePipe,
  ],
})
export class FooterComponent {
  protected readonly frontendVersion = packageJson.version;
}
